<div class="ft-profile-pic"
     [class]="size ? '-' + size : ''"
     [ftBackgroundImage]="imageUrl"
     [hidden]="!(isImageValid || initials)">
    <span [style.z-index]="isImageValid && initials ? '-1' : 'auto'" [hidden]="!initials" class="ft-profile-initials">{{ initials }}</span>
</div>
<span [hidden]="isImageValid || initials || !noProfilePic" class="ft-no-profile-pic">&mdash;</span>
